import { useCallback, useContext } from 'react';
import { imageViewerContext } from '../ImageViewerContext';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import useSmallDesktopScreen from 'hooks/useSmallDesktopScreen';
import {ArrowLeftFilled} from 'components/icons';

const useStyles = makeStyles(() => ({
  button: {
    left: '5%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(0, -50%)',
  },
  arrow: {
    width: 80,
    height: 80,
  }
}), { name: 'PreviousButton' });

const PreviousButton = (): JSX.Element | null => {
  const classes = useStyles();

  const { currentViewedImage, imageDocuments, handleCurrentViewedImage } = useContext(imageViewerContext);

  const isSmallScreen = useSmallDesktopScreen();

  const currentViewedImageIndex = imageDocuments.findIndex(
    image => image.id === currentViewedImage?.id,
  );
  const previousImage = imageDocuments[currentViewedImageIndex - 1];

  const handlePreviousImageClick = useCallback(
    () => handleCurrentViewedImage(previousImage),
  [previousImage, handleCurrentViewedImage]);

  if (isSmallScreen || currentViewedImageIndex < 1) {
    return null;
  }

  return (
    <Button
      className={classes.button}
      data-testid="previous-image-button"
      onClick={handlePreviousImageClick}
    >
      <ArrowLeftFilled className={classes.arrow} />
    </Button>
  );
};

export default PreviousButton;